module.exports = __webpack_public_path__ + "static/media/chto-eto-znachit.f41366fe.svg";